export const GENERAL_CONSTS = {
    SET_ROUTES:"SET_ROUTES",
    GET_USER:"GET_USER",
    GET_DEVICE:"GET_DEVICE",
    GET_INVITATIONS:"GET_INVITATIONS",
    GET_ACTIVITY:"GET_ACTIVITY",
    REMOVE_ACTIVITY:"REMOVE_ACTIVITY",
}
